import { styled } from 'styled-components';
import { Suspense } from 'react';
import { Spinner } from '@shopify/polaris';
const Loadable = (Component: any) => (props: any) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;

export function Loader() {
  const LoaderBackground = styled('div')`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999;
  `;
  const LoaderWrapper = styled('div')`
    display: flex;
    background: #fafafa;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  `;
  return (
    <LoaderBackground>
      <LoaderWrapper>
        <Spinner size="large" />
      </LoaderWrapper>
    </LoaderBackground>
  );
}
